import ReactCountryFlag from "react-country-flag";
import styles from "../rankings.module.scss";
import { Elide } from "./elide";

export function CountryCell({ getValue, row }) {
    const { countryCode } = row.original;
    return (
        <div className={styles.country}>
            <ReactCountryFlag
                svg
                countryCode={countryCode}
                style={{ height: "auto" }}
            />
            <Elide>{getValue()}</Elide>
        </div>
    );
}
